module.exports = {
    // 头部菜单
    header_menu: {
        logout: 'Sign out',
        index: 'Home page',
        game: 'Game',
        news: 'News',
        about: 'About Playcrab',
        JoinUs: 'Join us',
        Join: 'JOIN US',
    },
    // 标题
    title: {
        gname: 'GAME',
        gmore: 'View all games',
        nname: 'NEWS',
        nmore: 'See all the news'
    },
    //按钮
    btn: {
        explore: 'Explore',
        website: 'Enter  website'
    }
}


// WEBPACK FOOTER //
// ./src/language/en.js